import { useEffect, useMemo } from "react";
import { useItemPageContext } from "../../context";
import maskMoney from "../../../../utils/maskMoney";
import IncrementalButton from "../../../../components/incrementalButton";

const OrderSummary = () => {
  const {
    orderSummary,
    numOfProduct,
    addOneNumProduct,
    removeOneNumProduct,
    formIsValid,
    validateRequireds,
    totalFlavorsSelected,
    clickGoToCart,
  } = useItemPageContext();

  const totalValue = useMemo(
    () => orderSummary.total * numOfProduct,
    [orderSummary, numOfProduct],
  );

  useEffect(() => {
    validateRequireds();
  }, [totalFlavorsSelected]);

  return (
    <div>
      <h2 className="font-bold text-2xl mb-4">Resumo do pedido</h2>

      <div className="space-y-2 mb-6 max-w-xl">
        <div className="flex justify-between">
          <span className="text-md">Preço unitário:</span>
          <span className="text-md font-bold text-primary-500">
            {maskMoney(orderSummary.price)}
          </span>
        </div>
        {orderSummary.requireds.length > 0 && (
          <div>
            {orderSummary.requireds.map((required) => (
              <div className="pl-5 flex justify-between">
                <span className="text-md">{required.name}</span>
                {required.price > 0 && (
                  <span className="text-md font-bold text-primary-500">
                    {maskMoney(required.price)}
                  </span>
                )}
              </div>
            ))}
          </div>
        )}
        {orderSummary.additionals.length > 0 && (
          <div>
            <span className="text-md">Adicionais:</span>
            {orderSummary.additionals.map((additional) => (
              <div className="pl-5 flex justify-between">
                <span className="text-md">{additional.name}</span>
                {additional.price > 0 && (
                  <span className="text-md font-bold text-primary-500">
                    {maskMoney(additional.price)}
                  </span>
                )}
              </div>
            ))}
          </div>
        )}
        {orderSummary.total != totalValue && (
          <div className="flex justify-between">
            <span className="text-md">Subtotal:</span>
            <span className="text-md font-bold text-primary-500">
              {maskMoney(orderSummary.total)}
            </span>
          </div>
        )}
        <div className="flex justify-between">
          <span className="text-md">
            Total{numOfProduct > 1 ? ` (${numOfProduct}x)` : ""}:
          </span>
          <span className="text-md font-bold text-primary-500">
            {maskMoney(totalValue)}
          </span>
        </div>
      </div>

      <div className="flex gap-4">
        <IncrementalButton
          value={numOfProduct}
          onIncrease={addOneNumProduct}
          onDecrease={removeOneNumProduct}
        />

        <button
          disabled={!formIsValid}
          onClick={() => clickGoToCart()}
          className="bg-emerald-500 w-full rounded-lg font-bold text-lg text-white shadow-md flex items-center justify-between gap-2 h-14 px-4 disabled:bg-gray-400 hover:enabled:bg-emerald-600 transition-colors"
        >
          <span>ADICIONAR AO PEDIDO</span>
          <span>{maskMoney(totalValue)}</span>
        </button>
      </div>
    </div>
  );
};

export default OrderSummary;
